<template>
  <span>
    {{ formattedNumber }}
  </span>
</template>

<script>
import gsap from 'gsap';
export default {
  props: {
    value: {
      type: [Number, String],
      default: 0
    },
    start: {
      type: Number,
      default: 0
    },
    filter: {
      type: [String, Boolean],
      default: 'currency'
    },
    options: {
      type: Object,
      default: () => ({})
    },
    auto: Boolean
  },
  data() {
    return {
      tweenedNumber: this.start
    };
  },
  mounted() {
    const observeOptions = {
      root: null,
      threshold: 0.1
    };
    if (this.$device.intersectionObserver) {
      const observer = new IntersectionObserver(e => {
        const intersection = e[0];
        if (!intersection || intersection.intersectionRatio <= 0.1) return;
        this.animateTo(this.value);
      }, observeOptions);
      observer.observe(this.$el);
    }
    if (!this.$device.intersectionObserver || this.auto) this.animateTo(this.value);
  },
  watch: {
    value(newValue) {
      this.animateTo(newValue);
    }
  },
  computed: {
    formattedNumber() {
      if (isNaN(this.tweenedNumber)) return this.tweenedNumber;
      if (!this.filter) return Math.floor(this.tweenedNumber);
      return this.$options.filters[this.filter](Math.floor(this.tweenedNumber));
    }
  },
  methods: {
    animateTo(value) {
      gsap.to(this.$data, {
        duration: 1,
        tweenedNumber: value,
        ...this.options,
        onComplete: () => {
          this.$emit('done');
        }
      });
    }
  }
};
</script>

<style></style>
